import { render, staticRenderFns } from "./assetInventoryInStockList.vue?vue&type=template&id=37a4809c&scoped=true"
import script from "./assetInventoryInStockList.vue?vue&type=script&lang=js"
export * from "./assetInventoryInStockList.vue?vue&type=script&lang=js"
import style0 from "./assetInventoryInStockList.vue?vue&type=style&index=0&id=37a4809c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4809c",
  null
  
)

export default component.exports